import React from 'react';
import RegionSelector from './RegionSelector';
import LimitAndWeekendSettings from './LimitAndWeekendSettings';

const PackageSettingsCard = ({
  pkg,
  selectedRegions = [],
  onRegionsChange,
  limit = 100,
  onLimitChange,
  noWeekend = false,
  onNoWeekendChange
}) => {
  return (
    <div className="mt-3 pt-3 border-top" style={{ borderTopColor: '#e9ecef' }} onClick={(e) => e.stopPropagation()}>
      {pkg.id === 2 && (
        <RegionSelector
          selectedRegions={selectedRegions}
          onRegionsChange={onRegionsChange}
        />
      )}
      
      <LimitAndWeekendSettings
        limit={limit}
        onLimitChange={onLimitChange}
        noWeekend={noWeekend}
        onNoWeekendChange={onNoWeekendChange}
      />
    </div>
  );
};

export default PackageSettingsCard;